module.exports = __webpack_public_path__ + "fonts/Poppins-Light.6f5b7a1.woff";